export const continuationTokenHeaderName = 'X-Continuation';
export const waitForLoadingNewContentHeader = 'X-KC-Wait-For-Loading-New-Content';
export const sdkVersionHeader = 'X-KC-SDKID';
export const staleContentHeaderName = 'X-Stale-Content';
//# sourceMappingURL=headers.js.map